import { PLANET_IMAGES } from '@spacegame/assets/planets';
import type { PlanetBiome } from '@spacegame/ui';

/**
 * Owner-supplied renders (assets-src/planets/), grouped by biome. Several
 * biomes get more than one variant so neighbouring worlds don't all look
 * identical — matched by dominant colour against each biome's existing
 * accent (see BIOMES in PlanetVisual.tsx), e.g. the purple/lavender render
 * reads as "gas" because that biome's accent is already Aether-purple.
 */
const BIOME_IMAGES: Record<PlanetBiome, string[]> = {
  temperate: [PLANET_IMAGES.planet1, PLANET_IMAGES.planet6, PLANET_IMAGES.planet9],
  ice: [PLANET_IMAGES.planet2, PLANET_IMAGES.planet5],
  gas: [PLANET_IMAGES.planet3, PLANET_IMAGES.planet8],
  volcanic: [PLANET_IMAGES.planet4],
  barren: [PLANET_IMAGES.planet7],
  desert: [PLANET_IMAGES.planet10],
};

function hash(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (h * 31 + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

/** Deterministic pick so the same planet always renders the same art. */
export function planetImage(biome: PlanetBiome, seed: string): string {
  const variants = BIOME_IMAGES[biome];
  return variants[hash(seed) % variants.length] as string;
}
